import { Component, inject, signal, WritableSignal } from '@angular/core';
import { FormsModule, UntypedFormGroup } from '@angular/forms';

import { TranslatePipe } from '@ngx-translate/core';
import { ButtonDisableDirective } from '@shared/directives/button-disable.directive';
import { PasswordManagerService } from '@core/services/password-manager.service';

import {
  ButtonComponent,
  IGenCatForm,
  NgGenCatFormComponent,
} from '@ctti-dev/ng-gencat';

import { FORGOTTEN_PASSWORD_FORM_CONFIG } from './configurations/forgot-password.config';
import { Button } from '@shared/models/button.model';
import { ButtonConfigDirective } from '@shared/directives/button-config.directive';
import { PRIMARY_BUTTON } from '@shared/utils/utils.config';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    FormsModule,
    ButtonComponent,
    NgGenCatFormComponent,
    ButtonDisableDirective,
    TranslatePipe,
    ButtonConfigDirective,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  forgotPasswordForm!: UntypedFormGroup;

  readonly primaryButton: Partial<Button> = PRIMARY_BUTTON;
  readonly forgotPasswordFormConfig: IGenCatForm =
    FORGOTTEN_PASSWORD_FORM_CONFIG;

  readonly readyforgotPasswordSignal: WritableSignal<boolean> =
    signal<boolean>(false);

  private readonly _passwordManagerService = inject(PasswordManagerService);

  forgotPasswordFormLoaded(form: UntypedFormGroup): void {
    this.forgotPasswordForm = form;
    this.handleForgotPasswordButtonDisable();
  }

  forgotPassword(): void {
    const { username } = this.forgotPasswordForm.getRawValue();
    this._passwordManagerService.requestForgottenUserPasswordEmail(username);
  }

  private handleForgotPasswordButtonDisable(): void {
    this.forgotPasswordForm.valueChanges.subscribe(() => {
      const username = this.forgotPasswordForm.get('username')?.value;
      if (username) {
        this.readyforgotPasswordSignal.set(true);
      } else {
        this.readyforgotPasswordSignal.set(false);
      }
    });
  }
}
